import type { VariantDefinition } from '../factory';

export const badgeDefinition = {
  variants: {
    variant: {
      default: 'bg-primary border-transparent text-primary-foreground',
      secondary: 'bg-secondary border-transparent text-secondary-foreground',
      destructive: 'bg-destructive border-transparent text-white',
      success: 'bg-green-600 border-transparent text-white',
      warning: 'bg-amber-600 border-transparent text-white',
      info: 'bg-blue-600 border-transparent text-white',
      outline: 'border-input bg-background text-foreground',
    },
    size: {
      sm: 'h-4 px-2 text-xs min-w-4',
      default: 'h-5 px-2.5 text-xs min-w-5',
      lg: 'h-6 px-3 text-sm min-w-6',
    },
    shape: {
      default: 'rounded-full',
      square: 'rounded-md',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
    shape: 'default',
  },
} satisfies VariantDefinition;

export const badgeTextDefinition = {
  variants: {
    variant: {
      default: 'text-primary-foreground',
      secondary: 'text-secondary-foreground',
      destructive: 'text-white',
      success: 'text-white',
      warning: 'text-white',
      info: 'text-white',
      outline: 'text-foreground',
    },
    size: {
      sm: 'text-xs',
      default: 'text-xs',
      lg: 'text-sm',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
} satisfies VariantDefinition;

export type BadgeVariant = keyof typeof badgeDefinition.variants.variant;
export type BadgeSize = keyof typeof badgeDefinition.variants.size;
export type BadgeShape = keyof typeof badgeDefinition.variants.shape;
